import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { BaseSubsectionAdapter } from '../../../adapters/BaseSubsectionAdapter'
import { AdapterOptions, FlatAnswerMutation } from '../../../adapters/types'
import { SupervisoryFormData } from '../../types/SupervisoryFormData'
import { SupervisoryFormField } from '../../types/SupervisoryFormField'
import { SupervisoryAssessmentQuestionnaireItem } from '../../types/questionnaire'
import { getAnswerValuesFromItems } from '../../../helpers'

/**
 * Final Steps subsection adapter
 * Handles internal notes field extraction and transformation
 */
export class FinalStepsAdapter extends BaseSubsectionAdapter<SupervisoryFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    _options?: AdapterOptions
  ): Partial<SupervisoryFormData> {
    const flatAnswersArray = Object.values(flatAnswers)

    const finalStepsInternalNotes =
      getAnswerValuesFromItems(
        flatAnswersArray,
        SupervisoryAssessmentQuestionnaireItem.FINAL_STEPS_INTERNAL_NOTES
      )?.at(0) || undefined

    return {
      [SupervisoryFormField.FINAL_STEPS_INTERNAL_NOTES]: finalStepsInternalNotes
    }
  }

  buildFlatAnswers(): FlatAnswerMutation[] {
    const mutations: FlatAnswerMutation[] = []

    if (this.formDataFieldExists(SupervisoryFormField.FINAL_STEPS_INTERNAL_NOTES)) {
      mutations.push({
        linkId: SupervisoryAssessmentQuestionnaireItem.FINAL_STEPS_INTERNAL_NOTES,
        value: this.getFormDataField(SupervisoryFormField.FINAL_STEPS_INTERNAL_NOTES)
      })
    }

    return mutations
  }
}
